import React, { Fragment } from "react";
import ProductInlineList from "theme/modules/ProductList/Inline";
import { FormattedMessage } from "react-intl";
import { H3 } from "theme/components/atoms/Typography/Heading";
import { withHideOnErrorBoundary } from "theme/components/helpers/ErrorBoundary";
import { ProductSliderMobile } from "theme/components/organisms/ProductSlider";
import IsDesktop from "theme/utils/isDesktop";
const RelatedProducts = ({ products }) => (
  <div className="related-products">
    <IsDesktop>
      {(isDesktop) => {
        return isDesktop ? (
          <Fragment>
            <H3>
              <FormattedMessage
                id="modules.ProductList.RelatedProducts.tagline"
                defaultMessage="You might like"
              />
            </H3>
            <ProductInlineList
              products={products}
              length={3}
              productItemProp="isRelatedTo"
            />
          </Fragment>
        ) : (
          <ProductSliderMobile
            title={
              <FormattedMessage
                id="modules.ProductList.RelatedProducts.tagline"
                defaultMessage="You might like"
              />
            }
            headingLevel="h3"
            products={products}
          />
        );
      }}
    </IsDesktop>
  </div>
);

export default withHideOnErrorBoundary(RelatedProducts);
